import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class CountryService {
  async getCountryRiskData() {
    try {
      const response = await axios.get(`${API}/countries/risk`);
      return response.data;
    } catch (error) {
      console.error('Error fetching country risk data:', error);
      throw error;
    }
  }
}

export default new CountryService();
